// web/src/services/firestore/docTypesService.js
import { getApp } from 'firebase/app'
import {
  getFirestore,
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore'

/** Resolve Firestore without depending on your local firebase.js initialization order */
const db = (() => {
  try { return getFirestore(getApp()) } catch { return getFirestore() }
})()

function readSession() {
  try { return JSON.parse(localStorage.getItem('session') || 'null') || {} } catch { return {} }
}

function mapDoc(d) {
  const data = d.data() || {}
  return {
    id: d.id,
    name: data.name || '',
    isActive: data.isActive !== false,
    createdAt: data.createdAt || null,
    createdByEmail: data.createdByEmail || '',
    createdByName: data.createdByName || '',
    deletedAt: data.deletedAt || null,
    deletedByEmail: data.deletedByEmail || '',
    deletedByName: data.deletedByName || '',
    restoredAt: data.restoredAt || null,
    restoredByEmail: data.restoredByEmail || '',
    restoredByName: data.restoredByName || '',
  }
}

/**
 * List document types stored in Firestore.
 * Collection: `docTypes`
 * Each item: { id, name, isActive, createdAt, ... }
 *
 * @param {{onlyActive?: boolean}} opts
 */
export async function listDocTypesFS(opts = {}) {
  const snap = await getDocs(query(collection(db, 'docTypes'), orderBy('name')))
  let rows = snap.docs.map(mapDoc)
  if (opts.onlyActive) rows = rows.filter(r => r.isActive)
  return rows
}

/** Add a new document type (active by default). */
export async function addDocTypeFS(name) {
  const label = String(name || '').trim()
  if (!label) throw new Error('Type name is required.')

  const sess = readSession()
  const whoEmail = sess.email || ''
  const whoName  = sess.displayName || whoEmail || 'user'

  await addDoc(collection(db, 'docTypes'), {
    name: label,
    isActive: true,
    createdAt: serverTimestamp(),
    createdByEmail: whoEmail,
    createdByName: whoName,
    // clear any previous markers
    deletedAt: null,
    deletedByEmail: '',
    deletedByName: '',
    restoredAt: null,
    restoredByEmail: '',
    restoredByName: '',
  })
}

/** Soft delete (archive) a document type by id. */
export async function softDeleteDocTypeFS(id) {
  const sess = readSession()
  const whoEmail = sess.email || ''
  const whoName  = sess.displayName || whoEmail || 'user'

  await updateDoc(doc(db, 'docTypes', id), {
    isActive: false,
    deletedAt: serverTimestamp(),
    deletedByEmail: whoEmail,
    deletedByName: whoName,
  })
}

/** Restore an archived document type by id. */
export async function restoreDocTypeFS(id) {
  const sess = readSession()
  const whoEmail = sess.email || ''
  const whoName  = sess.displayName || whoEmail || 'user'

  await updateDoc(doc(db, 'docTypes', id), {
    isActive: true,
    deletedAt: null,
    deletedByEmail: '',
    deletedByName: '',
    restoredAt: serverTimestamp(),
    restoredByEmail: whoEmail,
    restoredByName: whoName,
  })
}